export const CONTACT_INFO_TITLE = "Step 2: Contact Information";
export const CONTACT_INFO_TITLE_NO_STEP =
  "Primary traveler contact information";
export const CONTACT_INFO_SUBTITLE =
  "Your host will use this information to communicate about your booking.";
export const CONTACT_INFO_SAVE = "Save Contact Information";
export const CONTACT_INFO_HELPER_TEXT =
  "You must select or add a traveler and enter their contact information to continue.";

export const TRAVELER_INFO_TITLE = "Step 1: Primary traveler information";
export const TRAVELER_HEADING = "Traveler";
export const TRAVELER_NAME = (firstName: string, lastName: string) =>
  `${firstName} ${lastName}`;
export const PHONE_HEADING = "Phone";
export const EMAIL_HEADING = "Email";
export const EDIT_TRAVELER = "Edit traveler";
